import { Card } from "@/components/ui/card";
import { Sparkles, Loader2 } from "lucide-react";

export function QuizAILoader() {
  return (
    <Card className="p-8 bg-gradient-to-br from-primary/5 to-primary/10 border-primary/20">
      <div className="flex flex-col items-center justify-center gap-4 py-8">
        <div className="relative">
          <div className="p-4 rounded-full bg-primary/10">
            <Sparkles className="h-8 w-8 text-primary" />
          </div>
          <Loader2 className="h-6 w-6 text-primary animate-spin absolute -bottom-1 -right-1" />
        </div>
        <div className="text-center space-y-2">
          <h3 className="text-xl font-semibold">Analizuję Twoje odpowiedzi...</h3>
          <p className="text-sm text-muted-foreground max-w-md">
            Nasze AI przygotowuje spersonalizowane rekomendacje na podstawie Twoich odpowiedzi w quizie
          </p>
        </div>
        <div className="flex gap-2 mt-4">
          <div className="h-2 w-2 rounded-full bg-primary animate-pulse" style={{ animationDelay: '0ms' }} />
          <div className="h-2 w-2 rounded-full bg-primary animate-pulse" style={{ animationDelay: '150ms' }} />
          <div className="h-2 w-2 rounded-full bg-primary animate-pulse" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </Card>
  );
}
